//Dev
export const apiURL = 'http://3.1.20.154:1001/api/one-water/';
//Production
// export const apiURL='http://52.221.200.207:1001/api/one-water/';
export const header = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + window.localStorage.getItem('token'),
}